import { useNavigate } from 'react-router-dom';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const StudyInfoHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const navigate = useNavigate();

    const buttonProps: HomeScreenButtonProps = {
        label: customLabel || 'Infos zur Studie',
        iconPath: 'information-less-intense.png',
        customIconSvg: customIcon
    };

    return (
        <HomeScreenButton
            buttonProps={buttonProps}
            action={() => navigate('study-info')}
            isHidden={false}
            disabled={false}
        />
    );
};
export default StudyInfoHomeScreenButton;